import { RootState } from './../app/store';
import moment from 'moment';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryParams } from 'use-query-params';
import { AppQueryParamsConfigMap } from '../app/constants';
import { LiveFeedEventRes } from '../domain';
import useDidUpdateEffect from '../hooks/useDidUpdate';
import { apiHttpService } from './apiHttpService';
import { setPage } from '../features/AllEvents/AllEvents.slice';
const ALL_EVENTS_PAGE_SIZE = 20;
const ALL_EVENTS_REFETCH_INTERVAL = 60000; // one minute;

export function useAllEvents(searchQuery: string) {
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const page = useSelector((state: RootState) => state.allEvents.page);
  const dispatch = useDispatch();

  const changePage = (page: number) => dispatch(setPage(page));


  // reset page when search changed
  useDidUpdateEffect(() => {
    changePage(0);
  }, [searchQuery]);

  const queryData = useQuery<LiveFeedEventRes>(
    [
      'events',
      page + 1,
      searchQuery,
      query.LocationID,
      query.SecretaryID,
      query.PCID,
      query.RCID,
    ],
    async () => {
      const queryParams = [
        `search=${searchQuery}`,
        `pageNo=${page + 1}`,
        `pageSize=${ALL_EVENTS_PAGE_SIZE}`,
        `LID=${query.LocationID}`,
        `SID=${query.SecretaryID}`,
        `PCID=${query.PCID}`,
        `RCID=${query.RCID}`,
      ];
      const { data } = await apiHttpService.get<LiveFeedEventRes | undefined>(
        `/GetEventsList?${queryParams.join('&')}`,
      );
      return data?.events?.length
        ? {
            ...data,
            events: data.events.map((item) => {
              return {
                ...item,
                eventDateGroup: moment(item.dateFrom).format('MMMM YYYY'),
              };
            }),
          }
        : {
            events: [],
            totalCount: 0,
            pageSize: ALL_EVENTS_PAGE_SIZE,
            pageNo: 0,
          };
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      refetchInterval: ALL_EVENTS_REFETCH_INTERVAL,
    },
  );

  return {
    ...queryData,
    page,
    changePage,
    pageSize: ALL_EVENTS_PAGE_SIZE,
  };
}
